import React, { Component } from 'react';
import { WithStyles, withStyles } from '@mui/styles';
import { withTranslate } from '../../../core/TenantProvider';

import classNames from 'classnames';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import APTableBlankDataStyle from './styles/APTableBlankData.style';
import ReferralsNoDataView from '../../../containers/ReferralsContainer/ReferralsNoDataView';
import { NO_SEARCH_DATA_TYPE } from '../../../core/utils/Constants/Constants';

interface APTableBlankDataProps extends WithStyles<typeof APTableBlankDataStyle> {
    className?: string,
    breakPoint?: number,
    referralSearchString: string,
    translate: Function
}


class APTableBlankData extends Component<APTableBlankDataProps, {}> {

    constructor(props: APTableBlankDataProps) {
        super(props);
    }

    render() {

        const {
            classes,
            translate,
            breakPoint,
            referralSearchString
        } = this.props;

        const match = window.matchMedia(`(max-width: ${breakPoint ? breakPoint : '840'}px)`);
        const responsiveClass = (match.matches) ? 'isResponsive' : '';

        let searchTableLoaders: any = [];

        searchTableLoaders.push(
            <div className={classes.tableSkeletonContainer}>
                <TableContainer className={classes.tableContainer}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan={12} className={classNames(classes.tableHeadingCell, classes.searchTableHeadingCell, responsiveClass)}>
                                    <span className={classes.searchDataTableHeadingCellSpan}>{translate('referrals.search.results.label', {
                                        searchValue: `"${referralSearchString}"`
                                    })}</span>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell colSpan={12} className={classNames(classes.tableHeadingCell, responsiveClass)}>
                                    <div className={classes.accountContainer}>
                                        <ReferralsNoDataView filterType={NO_SEARCH_DATA_TYPE} />
                                    </div>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        );

        return (
            <div className={classes.tableSkeleton}>{searchTableLoaders}</div>
        );

    }
}

export default withTranslate(withStyles(APTableBlankDataStyle)(APTableBlankData));
